import Vue from 'vue';

Vue.filter('coverImage', (src, _width = '', _height = '') => {
    return src ? src.split('?')[0] + '?imageMogr2/thumbnail/!' + _width + 'x' + _height + 'r/gravity/Center/crop/!' + _width + 'x' + _height : null;
});